'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ScoringModelRest = function () {
  function ScoringModelRest($http) {
    (0, _classCallCheck3.default)(this, ScoringModelRest);

    this.$http = $http;
    this.sprintf = require("sprintf-js").sprintf;

    this.PATH = {
      SCORING_MODEL_LIST: 'scoring-models/',
      SCORING_MODEL_DETAIL: 'scoring-models/%1$s/'
    };
  }

  (0, _createClass3.default)(ScoringModelRest, [{
    key: '_buildScoringModelFormData',
    value: function _buildScoringModelFormData(postData) {
      var fd = new FormData();
      if (postData.name) {
        fd.append('name', postData.name);
      }
      if (postData.key) {
        fd.append('key', postData.key);
      }
      if (postData.active) {
        fd.append('active', postData.active);
      }
      return fd;
    }
  }, {
    key: 'create',
    value: function create(postData) {
      var fd = this._buildScoringModelFormData(postData);

      return this.$http.post(this.PATH.SCORING_MODEL_LIST, fd);
    }
  }, {
    key: 'update',
    value: function update(id, postData) {
      var fd = this._buildScoringModelFormData(postData);

      return this.$http.patch(this.sprintf(this.PATH.SCORING_MODEL_DETAIL, id), fd);
    }
  }, {
    key: 'getList',
    value: function getList(params) {
      return this.$http.get(this.PATH.SCORING_MODEL_LIST, { params: params });
    }
  }, {
    key: 'read',
    value: function read(id) {
      return this.$http.get(this.sprintf(this.PATH.SCORING_MODEL_DETAIL, id));
    }
  }]);
  return ScoringModelRest;
}();

exports.default = ScoringModelRest;


//////////////////
// WEBPACK FOOTER
// ./src/api/ScoringModelResource.js
// module id = 338
// module chunks = 0